export default "__VITE_ASSET__BlnEy49j__"